function formatIntegerNumber(value: number, locale = 'pt-BR') {
  return new Intl.NumberFormat(locale, {
    maximumFractionDigits: 0, // Evita a exibição de casas decimais
  }).format(value);
}

export const maskIntegerNumber = (value: string): string => {
  if (!value) return '';

  // Remove qualquer coisa que não seja dígito
  const onlyDigits = value.replace(/\D/g, '');

  // Se o resultado for uma string vazia (ou seja, não havia dígitos), retorna vazio
  if (!onlyDigits) return '';

  // Converte a string de dígitos para número
  const numericValue = parseInt(onlyDigits, 10);

  // Formata o número como inteiro no formato brasileiro
  return formatIntegerNumber(numericValue);
};
